/**
 * Status numeric codes used by the API
 */
export const STATUS = {
    ALL: 0,
    DRAFT: 1,
    PENDING: 2,
    VALIDATED: 3,
    PUBLISHED: 4,
    EXPIRED: 5,
    ARCHIVED: 6,
    TRASHED: 7,
    DELETED: 8,
};

/**
 * Status display information for UI
 */
const STATUSES = [
    {
        type: 'all',
        translation: 'common.all',
        value: STATUS.ALL,
    },
    {
        type: 'draft',
        translation: 'common.draft',
        value: STATUS.DRAFT,
    },
    {
        type: 'pending',
        translation: 'common.pending',
        value: STATUS.PENDING,
    },
    {
        type: 'validated',
        translation: 'common.validated',
        value: STATUS.VALIDATED,
    },
    {
        type: 'published',
        translation: 'common.published',
        value: STATUS.PUBLISHED,
    },
    {
        type: 'expired',
        translation: 'common.expired',
        value: STATUS.EXPIRED,
    },
    {
        type: 'archived',
        translation: 'common.archived',
        value: STATUS.ARCHIVED,
    },
    {
        type: 'trashed',
        translation: 'common.trashed',
        value: STATUS.TRASHED,
    },
    {
        type: 'deleted',
        translation: 'common.deleted',
        value: STATUS.DELETED,
    }
];

export default STATUSES;
